// extracted by mini-css-extract-plugin
module.exports = {"Admin":"Admin_Admin__2oWjS","AdminView":"Admin_AdminView__2pfFi","children":"Admin_children__uw4m8"};